
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire293c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire293c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c286w", function(module, exports) {
class $61b781b208693d9b$var$ConstDavosMenu extends HTMLUListElement {
    connectedCallback() {
        let current = this.getAttribute("current");
        if (current) {
            let currentElem = this.querySelector("." + current);
            if (currentElem) currentElem.classList.add("current");
        }
    }
}
customElements.define("const-davos-menu", $61b781b208693d9b$var$ConstDavosMenu, {
    extends: "ul"
});

});

parcelRequire("c286w");
const $4bc8f3ae46736768$var$DAY_MS = 86400000;
class $4bc8f3ae46736768$var$OfferRequest {
    toJsonString() {
        return JSON.stringify(this);
    }
}
class $4bc8f3ae46736768$var$ConstDavosBooking extends HTMLDivElement {
    connectedCallback() {
        this.startInput = this.querySelector("#start");
        this.endInput = this.querySelector("#end");
        this.peopleInput = this.querySelector("#people");
        this.offer = this.querySelector(".offer");
        this.templateSrc = this.querySelector("template").content;
        let todayTime = new Date().getTime();
        this.startInput.valueAsDate = new Date(todayTime + $4bc8f3ae46736768$var$DAY_MS);
        this.endInput.valueAsDate = new Date(todayTime + 7 * $4bc8f3ae46736768$var$DAY_MS);
        this.startInput.addEventListener("change", ()=>this.onQueryChange());
        this.endInput.addEventListener("change", ()=>this.onQueryChange());
        this.peopleInput.addEventListener("change", ()=>this.onQueryChange());
    }
    onQueryChange() {
        this.setOfferSearch();
        let request = this.makeOfferRequest();
        fetch("/api/get-offer", {
            method: "POST",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            },
            body: request.toJsonString()
        }).then((response)=>response.json()).then((data)=>this.setOfferData(data)).catch((error)=>this.setOfferError(error));
    }
    makeOfferRequest() {
        let request = new $4bc8f3ae46736768$var$OfferRequest();
        request.startDate = this.startInput.valueAsDate;
        request.endDate = this.endInput.valueAsDate;
        request.adults = parseInt(this.peopleInput.selectedOptions[0].dataset.adults);
        request.children = parseInt(this.peopleInput.selectedOptions[0].dataset.children);
        return request;
    }
    setOfferSearch() {
        this.setOfferContent(this.templateSrc.querySelector(".search").cloneNode(true));
    }
    setOfferData(offerResponse) {
        if (!offerResponse.available) {
            this.setOfferContent(this.templateSrc.querySelector(".unavailable").cloneNode(true));
            return;
        }
        let offerContent = this.templateSrc.querySelector(".unavailable").cloneNode(true);
        offerContent.querySelector("time.start").textContent = offerResponse.startDate.toLocaleString();
        offerContent.querySelector("time.end").textContent = offerResponse.startDate.toLocaleString();
        offerContent.querySelector(".price").textContent = offerResponse.price.toString();
        this.setOfferContent(offerContent);
    }
    setOfferError(error) {
        let errorContent = this.templateSrc.querySelector(".error").cloneNode(true);
        errorContent.querySelector("span.details").textContent = error;
        this.setOfferContent(errorContent);
    }
    setOfferContent(content) {
        this.offer.innerHTML = "";
        this.offer.appendChild(content);
    }
}
customElements.define("const-davos-booking", $4bc8f3ae46736768$var$ConstDavosBooking, {
    extends: "div"
});


//# sourceMappingURL=booking.59f3f7bc.js.map
